import "./Products.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import TabbedProducts from "./sections/TabbedProducts";
export default function ProductsPage() {
  return <div>
      <FraternalExcellenceHeader />
      <TabbedProducts />
      <Footer />
    </div>;
}